import { useThemeStore } from '@/store/theme'

export function initializeEyeAble() {
    const themeStore = useThemeStore()

    themeStore.$subscribe((mutation, state) => {
        if (state.eyeAble && !window.eyeAbleLoaded) {
            window.eyeAbleLoaded = true

            const currentDomain = window.location.hostname

            const configScript = document.createElement('script')
            configScript.async = true
            configScript.src = `https://cdn.eye-able.com/configs/${currentDomain}.js`
            document.head.appendChild(configScript)

            const mainScript = document.createElement('script')
            mainScript.async = true
            mainScript.src = 'https://cdn.eye-able.com/public/js/eyeAble.js'
            document.head.appendChild(mainScript)

            const translateScript = document.createElement('script')
            translateScript.async = true
            translateScript.src = 'https://translate-cdn.eye-able.com/eye-able-translate.js'
            document.head.appendChild(translateScript)
        }
    })
}
